import { IEditEngagementRequestPayload, IEditEngagementSuccessPayload } from '../../types/bucket';
import { IApiError } from '../../types/shell';

export const EDIT_ENGAGEMENT_REQUEST = 'EDIT_ENGAGEMENT_REQUEST';
export const EDIT_ENGAGEMENT_SUCCESS = 'EDIT_ENGAGEMENT_SUCCESS';
export const EDIT_ENGAGEMENT_FAILURE = 'EDIT_ENGAGEMENT_FAILURE';

export const editEngagementRequest = (payload: IEditEngagementRequestPayload) => ({
  type: EDIT_ENGAGEMENT_REQUEST,
  payload,
});

export const editEngagementSuccess = (payload: IEditEngagementSuccessPayload) => ({
  type: EDIT_ENGAGEMENT_SUCCESS,
  payload,
});

export const editEngagementFailure = (payload?: IApiError) => ({
  type: EDIT_ENGAGEMENT_FAILURE,
  payload,
});
